import React from 'react'

export default class extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (<div>Menu Modification</div>)
  }
}




// WEBPACK FOOTER //
// ./app/App/Module/Menu/Page/Modification/index.js